<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
import { ref, type PropType } from 'vue'

interface CPasswordProps {
  rounded?: string | number | boolean
  variant?:
    | 'filled'
    | 'outlined'
    | 'plain'
    | 'underlined'
    | 'solo'
    | 'solo-inverted'
    | 'solo-filled'
}

const props = defineProps({
  color: {
    type: String,
    default: '',
  },
  rounded: {
    type: String as PropType<CPasswordProps['rounded']>,
    default: 'xl',
  },
  variant: {
    type: String as PropType<CPasswordProps['variant']>,
    default: 'outlined',
    validator: (value: string): boolean =>
      [
        'filled',
        'outlined',
        'plain',
        'underlined',
        'solo',
        'solo-inverted',
        'solo-filled',
      ].includes(value),
  },
  label: {
    type: String,
    default: 'title',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  hiddenDetail: {
    type: Boolean,
    default: true,
  },
  singleLine: {
    type: Boolean,
    default: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
})
const emits = defineEmits({
  changed: (event: string) => true,
})
const toggle = ref(false)
const model = defineModel()
</script>

<template>
  <v-text-field
    :label="props.label"
    :variant="props.variant"
    :hide-details="props.hiddenDetail"
    :single-line="props.singleLine"
    :rounded="props.rounded"
    :loading="props.loading"
    :disabled="props.disabled"
    :readonly="props.readonly"
    v-model="model"
    :type="toggle ? 'text' : 'password'"
    :append-inner-icon="toggle ? 'mdi-eye' : 'mdi-eye-off'"
    @click:append-inner="toggle = !toggle"
    @update:model-value="emits('changed', $event)"
  ></v-text-field>
</template>
